import { DynamicStandaloneLink, DynamicStandaloneLinkProps } from '@/components/Link';
import { StandaloneComponent } from '@/types/component';

export type StandaloneOptionalLinkProps = DynamicStandaloneLinkProps;

export const StandaloneOptionalLink: StandaloneComponent<StandaloneOptionalLinkProps> = ({
  content,
  href,
  ...props
}) => {
  return href ? <DynamicStandaloneLink {...{ content, href }} {...props} /> : content;
};

export default StandaloneOptionalLink;
